import { Loader2 } from "lucide-react";

export const Spinner = () => (
    <div className="flex items-center justify-center h-screen">
        <div className="loader mr-2">Chargement...</div>
        <Loader2 className="animate-spin" />
    </div>
);
